import { defineComponent } from 'vue';

export default defineComponent({
  methods: {
    asset(assetPath: string): string {
      return `${this.$store.getters['config/getBaseUrl']}${assetPath}`;
    }
  }
});
